import axios from "axios";
import Swal from "sweetalert2";

export default async function CloseServiceForm(rowData, fetchData) {
    const confirmClose = await Swal.fire({
        title: "Are you sure?",
        html: `Are you sure you want to request close releted service <b>${rowData.service_no}</b>?`,
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#fe7320",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, close it!",
    });

    if (confirmClose.value) {
        try {
            const { data } = await axios.patch(process.env.REACT_APP_WEBSITE_BACKEND_URL + `api/v1/services/close/${rowData ? (rowData.ref_service_id > 0 ? rowData.ref_service_id : rowData.service_id) : 0}`);

            Swal.fire({
                title: "Request Successfully!",
                text: data.message,
                icon: "success",
                showConfirmButton: false,
                timer: 2000,
            });
            
            fetchData();
        } catch (error) {
            Swal.fire({
                title: "Error!",
                text: error.response !== undefined && error.response.data !== undefined && error.response.data.message !== undefined ? error.response.data.message : error.message,
                icon: "error",
                confirmButtonColor: "#fe7320",
            });
        }
    }
}
